import * as pubSub from '../../utils/pub-sub.js';
import { CART_TRANSFER_INIT, CART_TRANSFER_READY, CART_TRANSFER_OPEN_MODAL } from '../../constants/events.js';
import * as commerceConnector from './cart-transfer.js';
import { setValueIfExist } from '../helper.js';
import { normalizeDataObject, validateDataObject } from '../../utils/index.js';
import { options as defaultOptions } from '../defaults.js';

/**
 * @typedef {import('./cart-transfer').CartTransferOptions} ChannelSightSettings
 */

function getLabels(labelsObject) {
  const labels = {};

  setValueIfExist(labels, 'ct_labels_modal_header', labelsObject.ctLabelsModalHeader);
  setValueIfExist(labels, 'ct_labels_search_title', labelsObject.ctLabelsSearchTitle);
  setValueIfExist(labels, 'ct_labels_search_placeholder', labelsObject.ctLabelsSearchPlaceholder);
  setValueIfExist(labels, 'ct_labels_search_button', labelsObject.ctLabelsSearchButton);
  setValueIfExist(labels, 'ct_labels_no_results', labelsObject.ctLabelsNoResults);
  setValueIfExist(labels, 'ct_labels_buy_cta_button', labelsObject.ctLabelsBuyCtaButton);
  setValueIfExist(labels, 'ct_labels_order_cta_button', labelsObject.ctLabelsOrderCtaButton);
  setValueIfExist(labels, 'ct_labels_details_title', labelsObject.ctLabelsDetailsTitle);
  setValueIfExist(labels, 'ct_labels_quantity', labelsObject.qtyLabel);
  setValueIfExist(labels, 'ct_labels_all_available_in_stock', labelsObject.ctLabelsAllAvailableInStock);
  setValueIfExist(labels, 'ct_labels_not_all_available_in_stock', labelsObject.ctLabelsNotAllAvailableInStock);
  setValueIfExist(labels, 'ct_labels_not_distributed', labelsObject.ctLabelsNotDistributed);
  setValueIfExist(labels, 'ct_labels_out_of_stock', labelsObject.ctLabelsOutOfStock);
  setValueIfExist(labels, 'ct_labels_expand_details', labelsObject.ctLabelsExpandDetails);
  setValueIfExist(labels, 'ct_labels_buy_online_btn_label', labelsObject.ctLabelsBuyOnlineBtnLabel);
  setValueIfExist(labels, 'ct_labels_not_distributed_online', labelsObject.ctLabelsNotDistributedOnline);
  setValueIfExist(labels, 'ct_labels_not_distributed_cta', labelsObject.ctLabelsNotDistributedCta);
  setValueIfExist(labels, 'ct_labels_not_distributed_cta_link', labelsObject.ctLabelsNotDistributedCtaLink);
  setValueIfExist(labels, 'ct_labels_expand_not_distributed', labelsObject.ctLabelsExpandNotDistributed);
  setValueIfExist(labels, 'ct_labels_zip_input_placeholder', labelsObject.ctLabelsZipInputPlaceholder);

  return labels;
}

function getMessages(messagesObject) {
  const messages = {};

  setValueIfExist(messages, 'ct_messages_not_distributed', messagesObject.ctMessagesNotDistributed);
  setValueIfExist(messages, 'ct_messages_invalid_zip_code_error', messagesObject.ctMessagesInvalidZipCodeError);
  setValueIfExist(messages, 'ct_messages_all_distributors_shown', messagesObject.ctMessagesAllDistributorsShown);
  setValueIfExist(messages, 'ct_messages_auto_detected_zip_code', messagesObject.ctMessagesAutoDetectedZipCode);
  setValueIfExist(messages, 'ct_messages_redirect_warning', messagesObject.ctMessagesRedirectWarning);

  return messages;
}

/**
 * @param {Array} products
 * @param {ChannelSightSettings} optionsObject
 * @param {object} labelsObject
 * @returns {Promise<object>}
 */
function initCartTransfer(products, optionsObject, labelsObject) {
  /** @type {ChannelSightSettings} */
  const options = normalizeDataObject(optionsObject, {
    defaults: defaultOptions,
    mappers: {
      zipCodePattern: RegExp
    }
  });

  if (!validateDataObject(options, {
    createURL: true,
    transferURL: true,
    apiKey: true,
    market: true
  })) {
    return Promise.reject();
  }

  const labels = getLabels(labelsObject);
  const messages = getMessages(labelsObject);

  commerceConnector.init(options, labels, messages, products);

  return commerceConnector.getRetailers();
}

export function subscribeToCartTransfer() {
    pubSub.subscribe(CART_TRANSFER_INIT,async ({ products, optionsObject, labelsObject }) => {
      try {
        const cartTransferResult = await initCartTransfer(products, optionsObject, labelsObject);
        pubSub.publish(CART_TRANSFER_READY, cartTransferResult);
      } catch(error) {
        pubSub.publish(CART_TRANSFER_READY, null);
      }     
    });

    pubSub.subscribe(CART_TRANSFER_OPEN_MODAL, ({ products, cartTransferResponseData }) => {
        commerceConnector.open(products, cartTransferResponseData);
    });
}
